/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum NoteTypeEnum {
    SIMPLE = 'simple',
    CALL = 'call',
    MAIL = 'mail',
    ACTIVITY = 'activity',
}
